var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Collapse = void 0;
var Collapse_1 = __importDefault(require("./Collapse"));
exports.Collapse = Collapse_1.default;
exports.default = Collapse_1.default;
//# sourceMappingURL=index.js.map